/**
 * The singular of the ENGLISH noun a page passes as `entityNoun`
 * ("recipients", "reported mails", "AI actions").
 *
 * Only English sentences splice the page's noun (every other language counts
 * "items" in its own words), and ICU plurals need both forms: "1 recipient",
 * "2 recipients". Pages pass the plural. The last word is made singular with
 * the regular English rules, plus "people"; stripping a final "s" alone, as
 * the table used to, gave "1 selected replie" and "1 selected people". A noun
 * these rules do not fit ("sheep") is returned unchanged.
 */
export function englishSingular(plural: string): string {
  if (/\bpeople$/i.test(plural)) return plural.replace(/people$/i, (word) => (word[0] === 'P' ? 'Person' : 'person'))
  if (/[^aeiou]ies$/i.test(plural)) return plural.replace(/ies$/i, 'y')
  if (/(?:ss|x|z|ch|sh)es$/i.test(plural)) return plural.replace(/es$/i, '')
  if (/[^s]s$/i.test(plural)) return plural.slice(0, -1)
  return plural
}
